import { Box, Divider } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import PlatformUrls from "../../../components/PlatformUrls";
import StaticIPDisplay from "../../../components/StaticIPDisplay";
import AppPage from "../../../components/structure/AppPage";

const StaticIPAddresses = () => {
  const colors = useColors();
  const cardWidth = "450px";
  return (
    <AppPage>
      <Box display="flex" flexDirection="column" gap={3}>
        <StaticIPDisplay containerWidth={cardWidth} />
        <Divider
          sx={{
            width: cardWidth,
            borderColor: colors.legend_separator,
          }}
        />
        <PlatformUrls containerWidth={cardWidth} />
      </Box>
    </AppPage>
  );
};

export default StaticIPAddresses;
